import { Injectable } from '@angular/core'
import { Store, Action } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import { getIsLoading, RootState } from './loader.selectors'
import { map } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class LoaderFacade implements GbBaseFacade {
  getIsLoading$ = (id: string | string[]) => this.store.select(getIsLoading(id))
  getIsLoaded$ = (id: string | string[]) => this.getIsLoading$(id).pipe(map((isLoading) => !isLoading))

  constructor(private store: Store<RootState>) {}

  dispatch(action: Action) {
    return this.store.dispatch(action)
  }
}
